module.exports = "/_next/static/images/c17a553397ab906fe06959c1493880d3-card-lg@2x.jpg";